import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function PopUp(props) {
    const { isOpen, toggle, imageSrc } = props;

    return (
        <div>
            <Modal className={'custom-modal'} isOpen={isOpen} toggle={toggle}>
                <ModalBody>
                    <img src={imageSrc} alt="Modal Image" style={{ width: '100%' }} />
                </ModalBody>
            </Modal>
        </div>
    );
}

export default PopUp;
